import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import isSenderImageEnabled from './isSenderImageEnabled';

/**
 * Returns whether the message list checkboxes (the select all checkbox in the
 * header and the per-row checkbox in the message list) should be hidden.
 *
 * The checkboxes are hidden when the ML checkbox behavior flight is enabled and
 * the sender image is turned off.
 */
export default function shouldHideMessageListCheckBoxes(): boolean {
    return isGlobalFeatureEnabled('tri-mlCheckboxBehavior-dev') && !isSenderImageEnabled();
}
